import { useEffect, useState } from 'react';
import type { GlobalAggregate } from '../lib/types';

interface Props {
  aggregate: GlobalAggregate;
}

// Mirrors functions/src/aggregates.ts's recomputeAggregates schedule.
const UPDATE_INTERVAL_MS = 6 * 60 * 60 * 1000;

function formatRemaining(ms: number): string {
  if (ms <= 0) return 'uppdaterar snart';
  const totalMin = Math.ceil(ms / 60_000);
  const h = Math.floor(totalMin / 60);
  const min = totalMin % 60;
  if (h === 0) return `om ${min} min`;
  if (min === 0) return `om ${h} tim`;
  return `om ${h} tim ${min} min`;
}

export function MapUpdateNotice({ aggregate }: Props) {
  const nextUpdateMs = aggregate.updatedAt.toMillis() + UPDATE_INTERVAL_MS;
  const [remaining, setRemaining] = useState(() => nextUpdateMs - Date.now());

  useEffect(() => {
    const id = setInterval(() => setRemaining(nextUpdateMs - Date.now()), 30_000);
    return () => clearInterval(id);
  }, [nextUpdateMs]);

  return (
    <p className="map-update-notice">
      Kartan uppdateras med erövringar var sjätte timme &middot; nästa uppdatering {formatRemaining(remaining)}
    </p>
  );
}
